'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414 from "./presto.-Dashboard-View$$anon$14.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024 from "./presto.types$-Dashboard-Host-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$13() {
  this.aKM = null;
  this.aKE = null;
  this.aKF = false;
  this.aKN = null;
  this.aKO = false;
  this.aKR = null;
  this.aKK = null;
  this.aKL = false;
  this.aKG = null;
  this.aKH = false;
  this.aKI = null;
  this.aKJ = false;
  this.aKP = false;
  this.aKQ = false;
  this.aKM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKR = "DashboardHostStats";
}
export { $c_Lpresto_DashboardView$$anon$13 as $c_Lpresto_DashboardView$$anon$13 };
$p = $c_Lpresto_DashboardView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$13;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$13() {
}
export { $h_Lpresto_DashboardView$$anon$13 as $h_Lpresto_DashboardView$$anon$13 };
$h_Lpresto_DashboardView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aKM;
});
$p.M = (function() {
  if ((!this.aKF)) {
    this.aKE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKF = true;
  }
  return this.aKE;
});
$p.O = (function() {
  if ((!this.aKO)) {
    this.aKN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKO = true;
  }
  return this.aKN;
});
$p.E = (function() {
  return this.aKR;
});
$p.t = (function() {
  if ((!this.aKL)) {
    this.aKK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("errors", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("parcel", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aKL = true;
  }
  return this.aKK;
});
$p.N = (function() {
  if ((!this.aKH)) {
    this.aKG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().va(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().mD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aKH = true;
  }
  return this.aKG;
});
$p.Q = (function() {
  if ((!this.aKJ)) {
    this.aKI = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414.$c_Lpresto_DashboardView$$anon$14();
    this.aKJ = true;
  }
  return this.aKI;
});
$p.v = (function() {
  if ((!this.aKQ)) {
    this.aKP = false;
    this.aKQ = true;
  }
  return this.aKP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee52) => ((p) => \u03b4scrutinee52.cFQ(p)))($j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024.$m_Lpresto_types$DashboardHostStats$())));
});
var $d_Lpresto_DashboardView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$13, "presto.DashboardView$$anon$13", ({
  Hb: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$13 as $d_Lpresto_DashboardView$$anon$13 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$13.js.map
